var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"dir":"auto"}},[_c('v-row',{attrs:{"dir":"auto"}},[_c('v-col',{attrs:{"cols":"12","dir":"auto"}},[_c('DataTableComponent',{ref:"dataTableComponent",attrs:{"table":_vm.tableData},on:{"deactivatedItem":function($event){return _vm.deactivateThisItem($event)}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }